import * as yup from 'yup';

export const employeeSchema = yup.object({
  employeeType: yup.string().notOneOf(['default'], 'El tipo de empleado es requerido'),
  shift: yup.string().notOneOf(['default'], 'El turno es requerido'),
  phoneNumber: yup.string().required('El número de teléfono es requerido'),
  firstName: yup.string().required('El primer nombre es requerido'),
  lastName: yup.string().required('El apellido es requerido'),
  email: yup.string().email('Formato de correo inválido').required('El correo electrónico es requerido'),
  password: yup.string().required('La contraseña es requerida'),
  idCardType: yup.string().notOneOf(['default'], 'El tipo de documento es requerido'),
  idcardNumber: yup
    .string()
    .when('idCardType', {
      is: 'ID',
      then: yup.string().matches(/^[VE]-\d{6,8}$/, 'Formato de cédula inválido (ej: V-12345678)')
    })
    .when('idCardType', {
      is: 'Passport',
      then: yup.string().matches(/^[A-Z0-9]{6,9}$/, 'Formato de pasaporte inválido')
    })
    .when('idCardType', {
      is: 'Rif',
      then: yup.string().matches(/^[VEJPG]-\d{8}-\d$/, 'Formato de RIF inválido (ej: J-12345678-9)')
    })
    .when('idCardType', {
      is: 'DrivingLicense',
      then: yup.string().required('El número de licencia es requerido')
    }),
  address: yup.string().required('La dirección es requerida'),
  idFile: yup.mixed(),
  salary: yup.number().required('El salario es requerido')
});

export const employeeSchemaForEdit = yup.object({
  employeeType: yup.string().notOneOf(['default'], 'El tipo de empleado es requerido'),
  shift: yup.string().notOneOf(['default'], 'El turno es requerido'),
  phoneNumber: yup.string().required('El número de teléfono es requerido'),
  firstName: yup.string().required('El primer nombre es requerido'),
  lastName: yup.string().required('El apellido es requerido'),
  idCardType: yup.string().notOneOf(['default'], 'El tipo de documento es requerido'),
  idcardNumber: yup
    .string()
    .when('idCardType', {
      is: 'ID',
      then: yup.string().matches(/^[VE]-\d{6,8}$/, 'Formato de cédula inválido (ej: V-12345678)')
    })
    .when('idCardType', {
      is: 'Passport',
      then: yup.string().matches(/^[A-Z0-9]{6,9}$/, 'Formato de pasaporte inválido')
    })
    .when('idCardType', {
      is: 'Rif',
      then: yup.string().matches(/^[VEJPG]-\d{8}-\d$/, 'Formato de RIF inválido (ej: J-12345678-9)')
    })
    .when('idCardType', {
      is: 'DrivingLicense',
      then: yup.string().required('El número de licencia es requerido')
    }),
  address: yup.string().required('La dirección es requerida'),
  idFile: yup.mixed(),
  idFile2: yup.mixed(),
  salary: yup.number().required('El salario es requerido')
});
